import type { Event, Media } from '@/payload-types'

/** Square MAHA mark already used for official event branding. */
export const OFFICIAL_EXTERNAL_EVENT_COVER =
  '/media/primary-logo-reverse-green-background-square.webp'

/**
 * Cover for an event card or detail page.
 * Official external events with no upload or Luma cover use the MAHA logo so the frame is not empty.
 */
export function eventCoverImage(
  event: Pick<Event, 'officialDesignation' | 'general'>,
): string | Media | number | null {
  const coverUrl = event.general?.coverUrl?.trim()
  if (coverUrl) return coverUrl

  const tempCover = event.general?.tempCoverImage
  if (tempCover) return tempCover

  if (event.officialDesignation === 'external') return OFFICIAL_EXTERNAL_EVENT_COVER

  return null
}
